"use strict";
window.theme = window.theme || {}
theme.MegaMenuSlider = function() {
    function MegaMenuSlider() {
        this.slider = {
            container: document.querySelectorAll('.navigation-product-section > .menu-product-container'),
            isDown: [],
            startX: [],
            scrollLeft: []
        } 
        this.container = {
            header: document.getElementById('shopify-section-header'),
            megamenu: document.querySelectorAll('.navigation__submenu'),
            megalinks: document.querySelectorAll('ul.header__links-list > li')
        }
            this.load();                      
    }
    MegaMenuSlider.prototype.load = function() {
        var _ = this;
        _.slider.container.forEach(el => {
            _.slider.isDown.push(false);
            _.slider.startX.push(0);
            _.slider.scrollLeft.push(0);
        });
        _.slider.container.forEach((el,index) => {
                el.addEventListener('mousedown', (e) => {
                if(e.target.parentElement.parentElement.parentElement.parentElement.closest('ul').classList.contains('navigation__submenu')) {
                    e.target.parentElement.parentElement.parentElement.parentElement.closest('ul').parentElement.classList.add('drag-is-enabled');
                } else {
                    e.target.parentElement.parentElement.parentElement.parentElement.closest('li').classList.add('drag-is-enabled');
                }
                
                _.slider.isDown[index] = true;
                el.classList.add('drag-enabled');
                _.slider.startX[index] = e.pageX - el.offsetLeft;
                _.slider.scrollLeft[index] = el.scrollLeft;
                });
        }); 
        _.slider.container.forEach((el,index) => {
                el.addEventListener('mouseleave', event => {
                _.slider.isDown[index] = false;
                el.classList.remove('drag-enabled');
                });
        }); 
        _.slider.container.forEach((el,index) =>  {
                el.addEventListener('mouseup', event => {
                    _.slider.isDown[index] = false;
                el.classList.remove('drag-enabled');
                });
        });
        _.slider.container.forEach((el,index) => {
                el.addEventListener('mousemove', (e) => {
                if(!_.slider.isDown[index]) return;
                e.preventDefault();
                const x = e.pageX - el.offsetLeft;
                const walk = (x - _.slider.startX[index]) * 3; //scroll-fast
                el.scrollLeft = _.slider.scrollLeft[index] - walk;
                });
        });     
    }    
    theme.MegaMenuSlider = new MegaMenuSlider;
}

theme.MegaMenuSlider();
